import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { AuthService } from '../auth.service';
import { Observable } from 'rxjs';
import { SessionService } from '../session.service';
import * as jwtDecode from 'jwt-decode';
import { IClaim } from 'src/app/models/claim/claim.interface';

/**
 * @ignore
 */
@Injectable({
  providedIn: 'root'
})
export class AuthGuard {

  userPermissions: string[];

  constructor(
    private authServ: AuthService,
    private sessionServ: SessionService,
    private router: Router
  ) {
    this.listenUser();
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (this.authServ.isAuthenticated()) {
      let hasPermission: boolean;

      if (next.data.permission) {
        hasPermission = this.authServ.hasPermission(next.data.permission);
      } else if (next.data.somePermission && Array.isArray(next.data.somePermission)) {
        hasPermission = next.data.somePermission.some((p: string) => this.authServ.hasPermission(p));
      } else if (next.data.everyPemission && Array.isArray(next.data.everyPemission)) {
        hasPermission = next.data.everyPemission.every((p: string) => this.authServ.hasPermission(p));
      } else {
        hasPermission = true;
      }

      if (hasPermission) {
        return true;
      } else {
        this.router.navigate(['/']);
        return false;
      }

    } else {
      let accessToken = '';
      // get access token from url param only if is trying to access dashboard page
      if (state.url.includes('/dashboard')) {
          accessToken = next.queryParamMap.get('token') || '';
      }
      console.log('[AuthGuard] Evaluating route access:', state.url.split('?')[0], '| token in URL:', !!accessToken);
      if (accessToken) {
        try {
          const claim: IClaim = jwtDecode(accessToken);
          // Assuming 'email' or 'preferred_username' is available in the claim for login identifier
          const loginIdentifier = claim.unique_name;
          this.authServ.login(accessToken, loginIdentifier);
          console.log('[AuthGuard] Login attempt finished, re-checking authentication');

          // Re-check authentication after attempting login with cookie
          if (this.authServ.isAuthenticated()) {
            console.log('User authenticated via token in URL');
            // remove token param from url
            console.log('[AuthGuard] Stripping token from URL query params');
            this.router.navigate([], {
              queryParams: { token: null },
              queryParamsHandling: 'merge'
            });
            return true;
          } else {
            console.log('[AuthGuard] Still unauthenticated after login attempt');
          }
        } catch (error) {
          this.authServ.deleteCookie('smart_token'); // Delete invalid cookie
        }
      }
      this.authServ.logout();
      return false;
    }
  }

  private listenUser() {
    this.sessionServ.user$.subscribe(res => {
      this.userPermissions = res && res.permissions ? res.permissions : [];
    });
  }

}
